import React, { useEffect, useRef, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { formatDate, formatToZMW, sumOfArray } from "../../../helpers";
import { FaSpinner, FaBalanceScale, FaBuilding, FaMoneyBillWave, FaChartLine, FaCalendarAlt } from "react-icons/fa";

const BalanceSheet = ({ rdata, startDate, endDate }) => {
  const [totalAssets, setTotalAssets] = useState(0);
  const [totalLiabilitiesEquity, setTotalLiabilitiesEquity] = useState(0);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true)
  const sumArray = (arr) => arr.reduce((sum, num) => sum + num, 0);
  
  

  const {allData, setAllData} = useOutletContext();
  const componentRef = useRef(null)
  const [loanAmount, setLoanAmount] = useState(0)

  useEffect(() => {
    if(rdata.bills){
      // displayBalanceSheet();
      
      let loan = 0
      rdata.bills.map((res)=>{
        
        if(allData.budget.find(a=>a.id === res.coa_id)?.coa === '157004'){
          loan += parseFloat(res.amount) - parseFloat(res.amount) * 0.05
        }
      })

      setLoanAmount(loan)
      setLoading(false)
    }
  }, [rdata]);

  useEffect(() => {
    if (!loading) {
      displayBalanceSheet();
    }
  }, [loanAmount, loading]);
  

  const displayBalanceSheet = () => {
    if (
      !rdata ||
      !Array.isArray(rdata.supplier) ||
      !Array.isArray(rdata.journal) ||
      !Array.isArray(rdata.bills) ||
      !Array.isArray(rdata.recs) ||
      !Array.isArray(rdata.cash) ||
      !Array.isArray(rdata.debt)
    ) {
      return;
    }

    if (!allData?.budget || !allData?.coa) {
      return;
    }

    const suppliers = rdata.supplier ?? [];
    const journal = rdata.journal ?? [];
    const bills = rdata.bills ?? [];
    const recs = rdata.recs ?? [];
    const cashData = rdata.cash ?? [];
    const debt = rdata.debt ?? [];

    let assets = 0;
    let liabilitiesEquity = 0;
    const tableRows = [];

    tableRows.push(
        <tr className="bg-gradient-to-r from-blue-950 to-blue-800 font-bold text-white" key="assets-header">
          <td className="px-4 py-3 border-b border-gray-300 flex items-center gap-2">
            <FaBalanceScale />
            Assets
          </td>
          <td className="px-4 py-3 border-b border-gray-300">Amount</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

    // Fixed Assets
    tableRows.push(
      <tr className="bg-gradient-to-r from-gray-100 to-gray-50 font-bold border-b-2 border-gray-300" key="fixed-assets-header">
        <td className="px-4 py-3 text-gray-700">Fixed Assets</td>
        <td className="px-4 py-3"></td>
        <td className="px-4 py-3"></td>
        <td className="px-4 py-3"></td>
      </tr>
    );

    suppliers
      .filter((a) => a.type == 1)
      .forEach((res) => {
        if(res.coa != 0){
          const coa = allData.budget.find((b) => b.id === res.coa)?.coa
        if (coa.substring(0, 2) == "31") {
          const fromCoa = sumArray(journal.filter((a) => a.from_coa === res.coa).map((r) => parseFloat(r.amount)));
          const toCoa = sumArray(journal.filter((a) => a.to_coa === res.coa).map((r) => parseFloat(r.amount)));
          const amount = parseFloat(res.amount) - fromCoa + toCoa;
          tableRows.push(
            <tr key={`fixed-asset-${res.coa}`} className="hover:bg-gray-50 transition-colors">
              <td className="px-4 py-3 border-b border-gray-200 pl-8 text-gray-700">{allData.coa.find((b) => b.account === coa).name}</td>
              <td className="px-4 py-3 border-b border-gray-200 text-right font-medium text-gray-800">{formatToZMW(amount)}</td>
              <td className="px-4 py-3 border-b border-gray-200"></td>
              <td className="px-4 py-3 border-b border-gray-200"></td>
            </tr>
          );

          assets += amount;
        }
        }
      });

     

    // Current Assets
    tableRows.push(
      <tr className="bg-gradient-to-r from-gray-100 to-gray-50 font-bold border-b-2 border-gray-300" key="current-assets-header">
        <td className="px-4 py-3 text-gray-700">Current Assets</td>
        <td className="px-4 py-3"></td>
        <td className="px-4 py-3"></td>
        <td className="px-4 py-3"></td>
      </tr>
    );
    suppliers
      .filter((a) => a.type == 1 && a.expense == 'None')
      .forEach((res) => {
        if(res.coa != 0){
        const coa = allData.budget.find((b) => b.id === res.coa).coa
        if (coa.substring(0, 2) == "32") {
          const amount = coa == '321040'?parseFloat(res.amount) - loanAmount:parseFloat(res.amount);
          
          if(amount !== 0){
            tableRows.push(
              <tr key={`current-asset-${res.coa}`}>
                <td className="px-4 py-3 border-b border-gray-300">{allData.coa.find((b) => b.account === coa).name}</td>
                <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(amount)}</td>
                <td className="px-4 py-3 border-b border-gray-300"></td>
                <td className="px-4 py-3 border-b border-gray-300"></td>
              </tr>
            );
            assets += amount;
          }
        
        }
      }
      });
let done = []
      suppliers
      .filter((a) => a.type == 1 && a.expense != 'None')
      .forEach((res) => {
        if(res.coa != 0){
        const coa = res.expense
        if (coa.substring(0, 2) == "32") {
          const isz = allData.budget?.find(item => item.coa === coa)?.id
          const fromCoa = sumArray(rdata.journal.filter((a) => a.from_coa === isz).map((r) => parseFloat(r.amount)));
          const toCoa = sumArray(rdata.journal.filter((a) => a.to_coa === isz).map((r) => parseFloat(r.amount)));
          let amount = 0
          if(done.includes(coa)){
            amount = parseFloat(res.amount)
          }else{
            amount = parseFloat(res.amount) - fromCoa + toCoa
          }
          done.push(coa)
          
          if(amount !==0){
            tableRows.push(
              <tr key={`current-asset-${res.coa}`} className="hover:bg-gray-50 transition-colors">
                <td className="px-4 py-3 border-b border-gray-200 pl-8 text-gray-700">{allData.coa.find((b) => b.account === coa).name}</td>
                <td className="px-4 py-3 border-b border-gray-200 text-right font-medium text-gray-800">{formatToZMW(amount)}</td>
                <td className="px-4 py-3 border-b border-gray-200"></td>
                <td className="px-4 py-3 border-b border-gray-200"></td>
              </tr>
            );
          }
          assets += amount;
        }
      }
      });



      const totalBills = sumArray(bills.map((res) => parseFloat(res.amount)));
      tableRows.push(
        <tr key="dca" className="hover:bg-gray-50 transition-colors">
          <td className="px-4 py-3 border-b border-gray-200 pl-8 text-gray-700">Debtors Control Account</td>
          <td className="px-4 py-3 border-b border-gray-200 text-right font-medium text-gray-800">{formatToZMW(totalBills - (recs[0]?.amount || 0))}</td>
          <td className="px-4 py-3 border-b border-gray-200"></td>
          <td className="px-4 py-3 border-b border-gray-200"></td>
        </tr>
      );
      assets += totalBills - (recs[0]?.amount || 0)
    // Add Cash
    const cash = parseFloat(cashData[0]?.difference || 0);
    tableRows.push(
      <tr key="cash" className="hover:bg-gray-50 transition-colors">
        <td className="px-4 py-3 border-b border-gray-200 pl-8 text-gray-700 flex items-center gap-2">
          <FaMoneyBillWave className="text-green-600" />
          Cash
        </td>
        <td className="px-4 py-3 border-b border-gray-200 text-right font-medium text-green-700">{formatToZMW(cash)}</td>
        <td className="px-4 py-3 border-b border-gray-200"></td>
        <td className="px-4 py-3 border-b border-gray-200"></td>
      </tr>
    );
    assets += cash;
    
    setTotalAssets(assets);
    
    tableRows.push(
        <tr className="bg-gradient-to-r from-gray-700 to-gray-800 font-bold text-white border-t-2 border-gray-400" key="total-assets">
          <td className="px-4 py-3 border-b border-gray-300 flex items-center gap-2">
            <FaBalanceScale />
            Total Assets
          </td>
          <td className="px-4 py-3 border-b border-gray-300 text-right text-lg">{formatToZMW(assets)}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );
    tableRows.push(
        <tr className="bg-gradient-to-r from-blue-950 to-blue-800 font-bold text-white" key="liabilities-header">
          <td className="px-4 py-3 border-b border-gray-300 flex items-center gap-2">
            <FaBuilding />
            Liabilities
          </td>
          <td className="px-4 py-3 border-b border-gray-300">Amount</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );
    // Liabilities
    const totalCredit = sumArray(suppliers.filter((a) => a.type == 1).map((res) => parseFloat(res.amount)));
    const totalCred = totalCredit - sumArray(suppliers.filter((a) => a.type == 2).map((res) => parseFloat(res.amount)))
    tableRows.push(
      <tr key="liabilities" className="hover:bg-gray-50 transition-colors">
        <td className="px-4 py-3 border-b border-gray-200 pl-8 text-gray-700">Creditors Control Account</td>
        <td className="px-4 py-3 border-b border-gray-200 text-right font-medium text-gray-800">{formatToZMW(totalCred)}</td>
        <td className="px-4 py-3 border-b border-gray-200"></td>
        <td className="px-4 py-3 border-b border-gray-200"></td>
      </tr>
    );
    liabilitiesEquity += totalCred;

    setTotalLiabilitiesEquity(liabilitiesEquity);
    tableRows.push(
        <tr className="bg-gradient-to-r from-gray-700 to-gray-800 font-bold text-white border-t-2 border-gray-400" key="total-liabilities">
          <td className="px-4 py-3 border-b border-gray-300 flex items-center gap-2">
            <FaBuilding />
            Total Liabilities
          </td>
          <td className="px-4 py-3 border-b border-gray-300 text-right text-lg">{formatToZMW(liabilitiesEquity)}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );
      
      let rev = 0 

      bills.map((res)=>{
        if(allData.budget.find(a=>a.id === res.coa_id)?.coa == "157004"){
          rev += parseFloat(res.amount) * 0.05
        }else{
          rev += parseFloat(res.amount)
        }
      })

      
      // calculate exp
      let exp = 0
      suppliers
          .filter((a) => a.type == 1 && a.expense == 'None')
          .forEach((res) => {
              const fromCoa = sumOfArray(
                  journal
                      .filter((a) => a.from_coa === res.coa)
                      .map((entry) => parseFloat(entry.amount))
              );
              const toCoa = sumOfArray(
                  journal
                      .filter((a) => a.to_coa === res.coa)
                      .map((entry) => parseFloat(entry.amount))
              );
      
              const coa = allData.budget?.find((b) => b.id === res.coa)?.coa;
              if (coa !== undefined && (coa[0] == "2")) {
                  const amount = parseFloat(res.amount) - fromCoa + toCoa;
                  const name = allData.coa?.find(item => item.account === coa)?.name || "Unknown";
      
                
      
                  exp += amount;
              }
          });

          journal.forEach((journalEntry) => {
            const coaCode = allData.budget?.find(item => item.id === journalEntry.to_coa)?.coa;
            const amount = parseFloat(journalEntry.amount);
            const name = allData.coa?.find(item => item.account === coaCode)?.name || "Unknown";
            let type = coaCode?.[0] == "1" ? "revenue" : "expense";
        
            if([3,4,5,6].includes(parseInt(coaCode?.[0]))){
        
            }else{
            if (type === "revenue") {
                rev += amount;
            } else {
              exp += amount;
            }
            }
        });

        // end calculation

      tableRows.push(
        <tr className="bg-gradient-to-r from-blue-950 to-blue-800 font-bold text-white" key="equity-header">
          <td className="px-4 py-3 border-b border-gray-300 flex items-center gap-2">
            <FaChartLine />
            Equity
          </td>
          <td className="px-4 py-3 border-b border-gray-300">Amount</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );


      tableRows.push(
        <tr className="hover:bg-gray-50 transition-colors">
          <td className="px-4 py-3 border-b border-gray-200 pl-8 text-gray-700">Accumulated Fund</td>
          <td className="px-4 py-3 border-b border-gray-200 text-right font-medium text-gray-800">{formatToZMW(sumArray(debt.filter(a=>a.type == 1).map((res) => parseFloat(res.amount))))}</td>
          <td className="px-4 py-3 border-b border-gray-200"></td>
          <td className="px-4 py-3 border-b border-gray-200"></td>
        </tr>
      );
      tableRows.push(
        <tr className="hover:bg-gray-50 transition-colors" key="surplus-deficit">
          <td className="px-4 py-3 border-b border-gray-200 pl-8 text-gray-700">Surplus (Deficit)</td>
          <td className={`px-4 py-3 border-b border-gray-200 text-right font-medium ${(rev - exp) >= 0 ? 'text-green-700' : 'text-red-700'}`}>{formatToZMW(rev - exp)}</td>
          <td className="px-4 py-3 border-b border-gray-200"></td>
          <td className="px-4 py-3 border-b border-gray-200"></td>
        </tr>
      );

   

      tableRows.push(
        <tr className="hover:bg-gray-50 transition-colors" key="returned-revenue">
          <td className="px-4 py-3 border-b border-gray-200 pl-8 text-gray-700">Returned Revenue</td>
          <td className="px-4 py-3 border-b border-gray-200 text-right font-medium text-gray-800">0</td>
          <td className="px-4 py-3 border-b border-gray-200"></td>
          <td className="px-4 py-3 border-b border-gray-200"></td>
        </tr>
      );

      tableRows.push(
        <tr className="hover:bg-gray-50 transition-colors" key="revaluation">
          <td className="px-4 py-3 border-b border-gray-200 pl-8 text-gray-700">Revaluation and Reserves</td>
          <td className="px-4 py-3 border-b border-gray-200 text-right font-medium text-gray-800">0</td>
          <td className="px-4 py-3 border-b border-gray-200"></td>
          <td className="px-4 py-3 border-b border-gray-200"></td>
        </tr>
      );

      tableRows.push(
        <tr className="bg-gradient-to-r from-gray-700 to-gray-800 font-bold text-white border-t-2 border-gray-400" key="total-equity">
          <td className="px-4 py-3 border-b border-gray-300 flex items-center gap-2">
            <FaChartLine />
            Total Equity
          </td>
          <td className="px-4 py-3 border-b border-gray-300 text-right text-lg">{formatToZMW(rev - exp + sumArray(rdata.debt.filter(a=>a.type == 1).map((res) => parseFloat(res.amount))))}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

      tableRows.push(
        <tr className="bg-gradient-to-r from-blue-600 to-blue-700 font-bold text-white border-t-2 border-blue-400" key="liabilities-equity">
          <td className="px-4 py-3 border-b border-gray-300 flex items-center gap-2">
            <FaBalanceScale />
            Liabilities plus Equity
          </td>
          <td className="px-4 py-3 border-b border-gray-300 text-right text-lg">{formatToZMW(liabilitiesEquity += rev - exp)}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

    setRows(tableRows);
  };

  return (
    <div className="w-full space-y-6">
      {
        loading?
        <>
        <div className='flex flex-col justify-center items-center h-64 w-full bg-white rounded-2xl border border-gray-100 shadow-sm'>
          <FaSpinner size={50} className="animate-spin text-blue-950 mb-4" />
          <p className="text-gray-600 text-lg">Loading balance sheet...</p>
        </div>
        </>
        :
        <>
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
            <div className=" px-6 py-4">
              <div className="flex items-center gap-3 mb-2">
                <div className="bg-blue-950 rounded-lg p-2">
                  <FaBalanceScale className="text-white text-xl" />
                </div>
                <div>
                  <h2 className='font-bold text-xl'>{allData.council[0]?.name.toUpperCase()}</h2>
                  <p className="text-gray-600 text-sm">Financial Position Statement</p>
                </div>
              </div>
              <div className="flex items-center gap-2 text-gray-600 text-sm">
                <FaCalendarAlt />
                <span>From {formatDate(startDate)} to {formatDate(endDate)}</span>
              </div>
            </div>
            
            <div className="p-6">
              <div className="overflow-x-auto">
                <table id="balance-sheet" className="w-full border-collapse">
                  <tbody>{rows}</tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      }

    </div>
  );
};

export default BalanceSheet;
